import React from "react";
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import News from "./news.js";
import Financial from "./financial.js";
import Sports from "./sports.js";
import Entertainment from "./entertainment.js";
import Health from "./health.js";
import 'bootstrap/dist/css/bootstrap.min.css';
import "./App.css";


function App() {
  return (
	
     <div className="tab-wrapper">
      <div className='container' >
		
        <div className="row">
<iframe width="1200" height="60" src="https://rss.app/embed/v1/ticker/_SsQ6UXSXUK2eKiHH" frameborder="0"></iframe>
          <div className="col-sm-12 tab-list-display">

            <Tabs defaultActiveKey="news">
              <Tab eventKey="news" title="News">
                <div className="tab-item-wrapper">
                  <News />
                </div>
              </Tab>

              <Tab eventKey="financial" title="Financial">
                <div className="tab-item-wrapper">
                  <Financial />
                </div>
              </Tab>

              <Tab eventKey="sports" title="Sports">
                <div className="tab-item-wrapper">
                   <Sports />
                </div>
              </Tab>

			<Tab eventKey="entertainment" title="Entertainment">
                <div className="tab-item-wrapper">
                  <Entertainment />
                </div>
              </Tab>

<Tab eventKey="health" title="Health">
                <div className="tab-item-wrapper">
                  <Health />
                </div>
              </Tab>
            </Tabs>

          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
